import { useMemo, useState } from 'react'
import * as React from 'react'
import styles from './Select.module.scss'
import cx from 'classnames'
import { ReactComponent as ChevronDownIcon } from 'assets/icons/chevronDown16.svg'
import { ReactComponent as ChevronUpIcon } from 'assets/icons/chevronUp16.svg'
import { ReactComponent as CheckIcon } from 'assets/icons/check16.svg'

export type SelectProps = {
  children: Array<React.ReactElement<OptionProps>>
  className?: string
  onChange?: (idx: number) => void
  selectDisabled?: boolean
}

export const Select: React.FC<React.PropsWithChildren<SelectProps>> = (props) => {
  const { className, children, onChange, selectDisabled } = props
  const [isOpen, setIsOpen] = useState(false)

  const selectedChild = useMemo(() => {
    return (
      (React.Children.toArray(children) as React.ReactElement<OptionProps>[]).find((child) => child.props.selected) ??
      React.Children.toArray(children)[0]
    )
  }, [children])

  const handleToggleSelect = () => {
    if (selectDisabled) return
    setIsOpen(!isOpen)
  }

  return (
    <div className={cx(styles.Select, className, { [styles.disabled]: selectDisabled })} data-test-id="formatBarSelect">
      <div className={cx(styles.selected, className)} onClick={handleToggleSelect}>
        {selectedChild} {isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
      </div>

      <ul className={cx(styles.options, { [styles.isOpen]: isOpen })}>
        {React.Children.map(children, (child, idx) => {
          const { className, disabled, selected, onSelect } = (child as React.ReactElement<OptionProps>).props
          return (
            <li
              className={cx(styles.option, className, { [styles.disabled]: disabled, [styles.selected]: selected })}
              onClick={() => {
                if (disabled) return
                onSelect?.()
                onChange?.(idx)
                setIsOpen(false)
              }}
            >
              {child}
              {selected && <CheckIcon />}
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export type OptionProps = {
  className?: string
  selected?: boolean
  disabled?: true
  onSelect?: () => void
}
export const Option: React.FC<React.PropsWithChildren<OptionProps>> = (props) => <>{props.children}</>
